import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import logo from "../../assets/logo.webp";
import { usePageSeo } from "../../seo/usePageSeo";
import "./ProblemasLogin.scss";

export default function ProblemasLogin() {
  const navigate = useNavigate();

  usePageSeo({
    title: "Problemas com login ou senha?",
    description:
      "Confirme se o login e senha foram digitados corretamente. Geralmente, o login corresponde ao número de matrícula da sua instituição.",
    path: "/problemas-login",
  });

  return (
    <div className="problemas-login">
      <img className="problemas-login__brand" src={logo} alt="AgendaUni" />
      <main className="problemas-login__card">
        <button
          className="problemas-login__back"
          onClick={() => navigate(-1)}
          type="button"
        >
          <ArrowLeft size={16} /> Voltar
        </button>

        <h1 className="problemas-login__title">
          Problemas com login ou senha?
        </h1>

        <section className="problemas-login__verifique">
          <h2>Verifique:</h2>
          <ul>
            <li>
              Confirme se o <strong>login e a senha</strong> foram digitados
              corretamente;
            </li>
            <li>
              Geralmente, o login corresponde ao{" "}
              <strong>número de matrícula</strong>;
            </li>
            <li>
              Certifique-se de que{" "}
              <strong>não há espaços antes ou depois</strong> do login ou da
              senha;
            </li>
            <li>
              Em alguns casos, o{" "}
              <strong>
                login pode incluir uma identificação da instituição
              </strong>{" "}
              (exemplo: matricula@instituicao);
            </li>
            <li>
              A senha pode ser composta por{" "}
              <strong>dados pessoais do usuário</strong>, como parte do CPF ou
              outro identificador pessoal.
            </li>
          </ul>
        </section>

        <section className="problemas-login__ajuda">
          <h2>Ainda não conseguiu acessar?</h2>
          <p>
            Se o problema persistir,{" "}
            <strong>
              entre em contato com o responsável ou coordenador da sua
              instituição
            </strong>{" "}
            para conferir seus dados de acesso ou solicitar a redefinição de
            senha.
          </p>
          <p>Caso seja necessário, entre em contato conosco:</p>
          <a
            href="mailto:uniagenda.contato@gmail.com"
            className="problemas-login__email"
          >
            <Mail size={16} /> uniagenda.contato@gmail.com
          </a>
        </section>

        <button
          className="problemas-login__cta"
          onClick={() => navigate("/")}
          type="button"
        >
          Voltar para a tela de login
        </button>
      </main>
    </div>
  );
}
